export const formatCurrency = ({ price, fraction }: { price: number | null; fraction?: boolean }) =>
  price?.toLocaleString('en-US', {
    currency: 'USD',
    maximumFractionDigits: fraction || (price < 1 && price > 0) ? 2 : 0,
    minimumFractionDigits: fraction || (price < 1 && price > 0) ? 2 : 0,
  })
